/**
 * The post-vote ask's words (2026-10-28): after a vote on any surface — the article body, the
 * conversation panel, the rail card, the phone's top bar — each asks "Why this one?" and leads
 * to the composer. Pure strings, one source, so the surfaces never drift apart.
 */

/** The post-vote ask on every surface; the chosen option already says "Your pick", so the label is never repeated. */
export const ASK_LINE = 'Why this one?'

/** Under the ask: social proof when the camp has threads, else an invitation. `threads` null = unknown (no list yet). */
export function campLine(threads: number | null, percent: number): string {
  // `percent`: the pick's share of the votes, already rounded to an integer by the caller.
  if (threads !== null && threads >= 2) {
    return `${threads} readers who picked this said why`
  }
  if (threads === 1) {
    return '1 reader who picked this said why'
  }
  return percent > 0 ? `Be the first of the ${percent}% to say why` : 'Be the first to say why'
}

/** Once the reader posted with their pick (`PollState.posted`). */
export const POSTED_LINE = 'Your take is in, with your pick.'

/** Pill / bar action label (callers add their own arrow glyph). */
export const SAY_WHY_ACTION = 'Say why'

/** The same action for a signed-out reader. Not the login dialog's copy object of the same name
 *  in `../comments/conversation/have-your-say.ts` (a `loginCopy` takes that one). */
export const SIGN_IN_TO_SAY_WHY = 'Sign in to say why'

/** Combined one-liner for narrow surfaces (rail, bar): "Why this one? · 3 readers who picked this said why" */
export function askLine(threads: number | null, percent: number): string {
  return `${ASK_LINE} · ${campLine(threads, percent)}`
}
